import { api } from './api';

const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || null,
    utm_medium: params.get('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || null,
    utm_content: params.get('utm_content') || null,
    utm_term: params.get('utm_term') || null,
  };
};

const clean = val => (typeof val === 'string' ? val.trim() : val);

const normaliseWebsite = val => {
  if (!val || !val.trim()) return null;
  let trimmed = val.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    trimmed = `https://${trimmed}`;
  }
  return trimmed;
};

/**
 * Securely submits a contact lead to cPanel REST API.
 */
export const submitContactLead = async (formData, normalizedWebsite) => {
  const utms = getUTMParams();
  
  const payload = {
    full_name: clean(formData.full_name),
    company_name: clean(formData.company_name),
    job_title: clean(formData.job_title),
    work_email: clean(formData.work_email).toLowerCase(),
    telephone: clean(formData.telephone),
    website: normalizedWebsite || normaliseWebsite(formData.website),
    industry: formData.industry,
    country: clean(formData.country),
    service_interest: formData.service_interest || null,
    business_challenge: clean(formData.business_challenge),
    message: clean(formData.message),
    preferred_start_date: formData.preferred_start_date || null,
    referral_source: clean(formData.referral_source) || null,
    consent: formData.consent === true,
    ...utms
  };

  return await api.submitContact(payload);
};

/**
 * Securely submits an Intelligence Review lead to cPanel REST API.
 */
export const submitIntelligenceReviewLead = async (formData) => {
  const utms = getUTMParams();

  const payload = {
    full_name: clean(formData.full_name),
    company_name: clean(formData.company_name),
    job_title: clean(formData.job_title),
    work_email: clean(formData.work_email).toLowerCase(),
    telephone: clean(formData.telephone),
    website: normaliseWebsite(formData.website),
    industry: clean(formData.industry),
    country: clean(formData.country),
    marketing_challenge: clean(formData.marketing_challenge),
    primary_market: clean(formData.primary_market),
    competitors: formData.competitors,
    competitor_websites: clean(formData.competitor_websites) || null,
    monitoring_platforms: formData.monitoring_platforms || [],
    competitive_concern: clean(formData.competitive_concern),
    current_advertising_platforms: formData.current_advertising_platforms || [],
    campaign_objective: clean(formData.campaign_objective),
    desired_result: clean(formData.desired_result),
    monthly_advertising_range: clean(formData.monthly_advertising_range) || null,
    preferred_contact_method: clean(formData.preferred_contact_method),
    preferred_start_date: formData.preferred_start_date || null,
    referral_source: clean(formData.referral_source) || null,
    consent: formData.consent === true,
    ...utms
  };

  return await api.submitReview(payload);
};

/**
 * Subscribes an email to the Maxmark Intelligence Briefs newsletter.
 */
export const subscribeNewsletter = async (email) => {
  return await api.subscribeNewsletter(email);
};